import {
    AppBar,
    Backdrop,
    Box,
    Button,
    ButtonGroup,
    CircularProgress,
    Dialog,
    Fade,
    Grid,
    InputAdornment,
    Menu,
    MenuItem,
    Snackbar,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../styles/layout/header.module.scss";
import styles1 from "../../styles/layout/userlayout/userheader.module.scss";
import logo from "../../public/assets/images/main_logo.png";
import noUser from "../../public/assets/images/profile_img.svg";
import HeaderSearchIcon from "../../ui/Icons/HeaderSearchIcon";
import HeaderMessageIcon from "../../ui/Icons/HeaderMessageIcon";
import HeaderNotificationIcon from "../../ui/Icons/HeaderNotificationIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import CrossIcon from "../../ui/Icons/CrossIcon";
import UploadPin from "../../ui/Icons/UploadPin";
import { parseCookies } from "nookies";
import {
    getAbsoluteImageURI,
    getStyledDateTime,
} from "../../lib/functions/utils.lib";
import useFetch, { usePost } from "../../hooks/api/useFetch";
import { useDispatch } from "react-redux";
import assest from "../../json/assest";
import BlueDoubleTickIcon from "../../ui/Icons/BlueDoubleTickIcon";
import axiosInstance from "../../api/axiosInstance";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
    setCheck,
    updateQuery,
} from "../../redux-toolkit/slices/searchQuery.slice";

const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "72px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0",
            },
        },
    },
};

export default function UserHeader({ headerPurchaseBtn }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setMessageAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setMessageAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setMessageAnchorEl(null);
    };

    const [notificationAnchorEl, setNotificationAnchorEl1] =
        React.useState(null);
    const open1 = Boolean(notificationAnchorEl);
    const handleClick1 = (event) => {
        setNotificationAnchorEl1(event.currentTarget);
    };
    const handleClose1 = () => {
        setNotificationAnchorEl1(null);
    };
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [searchState, setSearchState] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [purchsereqstModal, setPurchsereqstModal] = useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);

    const purchsereqstModalClick = () => {
        setPurchsereqstModal(true);
    };
    const purchsereqstModalClose = () => {
        setPurchsereqstModal(false);
    };

    const handleSnackbarClick = () => {
        setSnackOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackOpen(false);
    };

    const cookies = parseCookies();
    const userData = JSON.parse(cookies?.userdetails || "{}");

    const {
        data: contentBuyerData,
        isLoading: contentBuyerIsLoading,
        isSuccess: contentBuyerIsSuccess,
        refetch: contentBuyerRefetch,
    } = useFetch(["contentBuyer", userData?.id], "user");

    const {
        data: notificationsList,
        isSuccess: notificationsListIsSuccess,
        isError: notificationsListIsError,
        isLoading: notificationsListIsLoading,
        refetch: refetchNotificationsList,
    } = usePost(["unseen-notifications"], `notifications`, {
        notification_type_id:
            "1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 44, 46, 49",
        seen: 0,
        archive: 0,
    });

    const {
        data: messageNotificationsList,
        isSuccess: messageNotificationsListIsSuccess,
        isError: messageNotificationsListIsError,
        isLoading: messageNotificationsListIsLoading,
        refetch: refetchMessageNotificationsList,
    } = usePost(["unseen-message-notifications"], `notifications`, {
        notification_type_id: "47, 48",
        seen: 0,
        archive: 0,
    });

    const updateNotification = async (data) => {
        await axiosInstance
            .post("notification-status-update", data)
            .then((res) => {
                refetchNotificationsList();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const updateNotificationSeen = (notification) => {
        updateNotification({
            notification_id: notification?.id,

            seen: notification?.seen ? 0 : 1,
        });
    };
    const updateNotificationArchive = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            archive: 1,
        });
    };

    const updateNotificationReadAll = () => {
        updateNotification({ read_all: "yes" });
    };

    const { query, check } = useAppSelector((s) => s.searchQuerySlice);
    const [inSearchPage, setInSearchpage] = useState(true);

    const goToMessage = (inquiryId) => {
        if (!inquiryId) return;
        navigate(`content-buyer-dashboard/message/${inquiryId}`);
    };

    const handleSearch = () => {
        navigate("/content-buyer-dashboard/search-result");
        dispatch(updateQuery(query));
        if (query) {
            dispatch(setCheck(true));
        }
    };

    const handleClear = () => {
        navigate("/content-buyer-dashboard");
        dispatch(updateQuery(""));
        if (query) {
            dispatch(setCheck(false));
        }
    };

    React.useEffect(() => {
        if (location.pathname !== "/content-buyer-dashboard/search-result") {
            dispatch(updateQuery(""));
            dispatch(setCheck(false));
        }
    }, [dispatch, location.pathname]);

    React.useEffect(() => {
        if (location.pathname === "/content-buyer-dashboard/search-result") {
            setInSearchpage(false);
            if (query?.length > 1) {
                dispatch(setCheck(true));
            }
        }
    }, [dispatch, location.pathname]);

    const handleFade = () => {
        setSearchState(false);
        setBackdropOpen(!backdropOpen);
        if (location.pathname !== "/content-buyer-dashboard/search-result") {
            dispatch(updateQuery(""));
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        handleSearch();
    };

    return (
        <>
            <AppBar
                component={"nav"}
                position="static"
                elevation={0}
                className={styles.headerAppbar}
            >
                <Toolbar>
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        flexWrap={"wrap"}
                        className={styles.mainHeader}
                    >
                        <Box className={styles.headerLeft}>
                            <Link to="/">
                                <img
                                    src={logo}
                                    alt=""
                                    width={133}
                                    height={29}
                                />
                            </Link>
                        </Box>
                        <Box className={styles.headerRight}>
                            <form action="" onSubmit={handleSubmit}>
                                <Box
                                    className={`${styles.search_box} ${
                                        searchState && inSearchPage
                                            ? `${styles.openSearchBox}`
                                            : ""
                                    }`}
                                    onSubmit={handleSubmit}
                                >
                                    <TextField
                                        label=""
                                        id="outlined-size-normal"
                                        placeholder="Enter an email address, submitter name, VSID to search..."
                                        onClick={() => {
                                            setBackdropOpen(true);
                                            setSearchState(true);
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                    className={
                                                        query
                                                            ? styles.startAdmnt
                                                            : undefined
                                                    }
                                                >
                                                    <HeaderSearchIcon />
                                                </InputAdornment>
                                            ),

                                            endAdornment:
                                                backdropOpen && inSearchPage ? (
                                                    <InputAdornment position="end">
                                                        {!check ? (
                                                            <Button
                                                                onClick={
                                                                    handleSearch
                                                                }
                                                                disabled={
                                                                    query?.length ===
                                                                        0 ||
                                                                    query?.length ===
                                                                        undefined
                                                                }
                                                            >
                                                                Search
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                onClick={
                                                                    handleClear
                                                                }
                                                                className={
                                                                    styles.clearBtn
                                                                }
                                                            >
                                                                clear
                                                            </Button>
                                                        )}
                                                    </InputAdornment>
                                                ) : location.pathname ===
                                                      "/content-buyer-dashboard/search-result" &&
                                                  query?.length > 0 ? (
                                                    <Button
                                                        onClick={handleClear}
                                                        className={
                                                            styles.clearBtn
                                                        }
                                                    >
                                                        clear
                                                    </Button>
                                                ) : null,
                                        }}
                                        value={query}
                                        onChange={(e) =>
                                            dispatch(
                                                updateQuery(e.target.value)
                                            )
                                        }
                                        sx={
                                            query
                                                ? {
                                                      border: "1px solid #111AE9",
                                                      borderRadius: "6px",
                                                  }
                                                : undefined
                                        }
                                    />
                                    <Fade
                                        in={backdropOpen && inSearchPage}
                                        unmountOnExit
                                        mountOnEnter
                                        timeout={{
                                            enter: 500,
                                            exit: 800,
                                            appear: 400,
                                        }}
                                    >
                                        <Box
                                            className={styles.srchBackdrop}
                                            onClick={handleFade}
                                        ></Box>
                                    </Fade>
                                </Box>
                            </form>
                            <Box className={styles.headerprofileSec}>
                                {headerPurchaseBtn && (
                                    <Button
                                        className={styles1.purchaseBtnYlw}
                                        onClick={purchsereqstModalClick}
                                    >
                                        New Purchase Request
                                    </Button>
                                )}

                                <ButtonGroup>
                                    <Button onClick={handleClick}>
                                        <HeaderMessageIcon />
                                        {messageNotificationsList?.data?.data
                                            ?.length ? (
                                            <span></span>
                                        ) : null}
                                    </Button>
                                    <Menu
                                        anchorEl={anchorEl}
                                        id="message-menu"
                                        open={open}
                                        onClose={handleClose}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: "visible",
                                                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                                mt: 1.5,
                                                maxWidth: "447px",
                                                borderRadius: "13px",
                                                width: "100%",
                                                "& .MuiList-root": {
                                                    padding: "0",
                                                },
                                                "& .scrollbar-container": {
                                                    "& .ps__rail-x": {
                                                        display: "none",
                                                    },
                                                    "& .ps__rail-y": {
                                                        right: "5px !important",
                                                    },
                                                },
                                                "& .msgContent": {
                                                    width: "calc(100% - 26px)",
                                                },
                                            },
                                        }}
                                        className={styles.menuPop}
                                        transformOrigin={{
                                            horizontal: "right",
                                            vertical: "top",
                                        }}
                                        anchorOrigin={{
                                            horizontal: "right",
                                            vertical: "bottom",
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            flexWrap="wrap"
                                            justifyContent="space-between"
                                            className={styles.popupHeader}
                                        >
                                            <Typography variant="caption">
                                                Messages
                                            </Typography>
                                            <Button onClick={handleClose}>
                                                <img
                                                    src={assest.iconCross}
                                                    width={9}
                                                    height={9}
                                                    alt="icon"
                                                />
                                            </Button>
                                        </Stack>
                                        <PerfectScrollbar>
                                            <Box className={styles.listBox}>
                                                {messageNotificationsListIsLoading ? (
                                                    <Typography variant="body1">
                                                        Loading...
                                                    </Typography>
                                                ) : messageNotificationsListIsSuccess ? (
                                                    messageNotificationsList
                                                        ?.data?.data?.length ? (
                                                        messageNotificationsList?.data?.data?.map(
                                                            (item, index) => (
                                                                <MenuItem
                                                                    key={index}
                                                                    disableGutters
                                                                    onClick={() =>
                                                                        goToMessage(
                                                                            item?.id
                                                                        )
                                                                    }
                                                                >
                                                                    <Stack
                                                                        direction="row"
                                                                        className={
                                                                            styles.innerListWrap
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={getAbsoluteImageURI(
                                                                                item?.icon
                                                                            )}
                                                                            width={
                                                                                26
                                                                            }
                                                                            height={
                                                                                26
                                                                            }
                                                                            alt="icon"
                                                                        />
                                                                        <Box
                                                                            className={`${styles.msgTxt} msgContent`}
                                                                        >
                                                                            <p>
                                                                                {
                                                                                    item?.title
                                                                                }
                                                                            </p>
                                                                            <span>
                                                                                {getStyledDateTime(
                                                                                    item?.created_at
                                                                                )}
                                                                            </span>
                                                                        </Box>
                                                                    </Stack>
                                                                </MenuItem>
                                                            )
                                                        )
                                                    ) : (
                                                        <Stack
                                                            justifyContent={
                                                                "center"
                                                            }
                                                            alignItems={
                                                                "center"
                                                            }
                                                            className={
                                                                styles.noItemForPopup
                                                            }
                                                        >
                                                            <figure>
                                                                <img
                                                                    src={
                                                                        assest.mail
                                                                    }
                                                                    width={34}
                                                                    height={24}
                                                                    alt="icon"
                                                                />
                                                            </figure>
                                                            <Typography variant="body1">
                                                                You're all clear
                                                                - no new
                                                                notifications
                                                            </Typography>
                                                        </Stack>
                                                    )
                                                ) : (
                                                    ""
                                                )}
                                            </Box>
                                        </PerfectScrollbar>
                                        <Stack
                                            justifyContent="flex-end"
                                            direction="row"
                                            className={styles.popupFooter}
                                        >
                                            <Button
                                                onClick={() =>
                                                    navigate(
                                                        "/content-buyer-dashboard/message"
                                                    )
                                                }
                                            >
                                                Go to My Messages
                                            </Button>
                                        </Stack>
                                    </Menu>
                                    <Button onClick={handleClick1}>
                                        <HeaderNotificationIcon />
                                        {notificationsList?.data?.data
                                            ?.length ? (
                                            <span></span>
                                        ) : null}
                                    </Button>
                                    <Menu
                                        anchorEl={notificationAnchorEl}
                                        id="notification-menu"
                                        open={open1}
                                        onClose={handleClose1}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: "visible",
                                                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                                mt: 1.5,
                                                maxWidth: "447px",
                                                borderRadius: "13px",
                                                width: "100%",
                                                "& .MuiList-root": {
                                                    padding: "0",
                                                },
                                                "& .scrollbar-container": {
                                                    "& .ps__rail-x": {
                                                        display: "none",
                                                    },
                                                    "& .ps__rail-y": {
                                                        right: "5px !important",
                                                    },
                                                },
                                                "& .msgContent": {
                                                    width: "calc(100% - 26px)",
                                                },
                                            },
                                        }}
                                        className={styles.menuPop}
                                        // transformOrigin={{
                                        //   horizontal: "right",
                                        //   vertical: "top",
                                        // }}
                                        // anchorOrigin={{
                                        //   horizontal: "right",
                                        //   vertical: "bottom",
                                        // }}
                                    >
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            flexWrap="wrap"
                                            justifyContent="space-between"
                                            className={`${styles.popupHeader} ${styles.popupHeaderNotification}`}
                                        >
                                            <Typography variant="caption">
                                                Notification
                                            </Typography>
                                            <Button onClick={handleClose1}>
                                                <img
                                                    src={assest.iconCross}
                                                    width={9}
                                                    height={9}
                                                    alt="icon"
                                                />
                                            </Button>
                                        </Stack>
                                        <PerfectScrollbar>
                                            <Box
                                                className={`${styles.listBox} ${styles.listBoxNotification}`}
                                            >
                                                {notificationsListIsLoading ? (
                                                    <Typography variant="body1">
                                                        Loading...
                                                    </Typography>
                                                ) : notificationsListIsSuccess ? (
                                                    notificationsList?.data
                                                        ?.data?.length ? (
                                                        notificationsList?.data?.data?.map(
                                                            (item, index) => {
                                                                return (item?.notification_type_id ===
                                                                    47 ||
                                                                    item?.notification_type_id ===
                                                                        48) ===
                                                                    true ? null : (
                                                                    <MenuItem
                                                                        key={
                                                                            index
                                                                        }
                                                                        onClick={
                                                                            handleClose
                                                                        }
                                                                        disableGutters
                                                                    >
                                                                        <Stack
                                                                            direction="row"
                                                                            className={
                                                                                styles.innerListWrap
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={getAbsoluteImageURI(
                                                                                    item?.icon
                                                                                )}
                                                                                width={
                                                                                    26
                                                                                }
                                                                                height={
                                                                                    26
                                                                                }
                                                                                alt="icon"
                                                                            />
                                                                            <Box
                                                                                className={`${styles.msgTxt} msgContent`}
                                                                            >
                                                                                <p>
                                                                                    {
                                                                                        item?.title
                                                                                    }
                                                                                </p>
                                                                                <span>
                                                                                    {getStyledDateTime(
                                                                                        item?.created_at
                                                                                    )}
                                                                                </span>
                                                                            </Box>
                                                                        </Stack>
                                                                        <Box
                                                                            className={
                                                                                styles.btnOverlay
                                                                            }
                                                                        >
                                                                            {(item?.notification_type_id ===
                                                                                47 ||
                                                                                item?.notification_type_id ===
                                                                                    48) ===
                                                                            true ? (
                                                                                <Link
                                                                                    to={`/${
                                                                                        item?.type ===
                                                                                        "Message"
                                                                                            ? "message-details"
                                                                                            : "support-details"
                                                                                    }/${
                                                                                        item?.inquiry_id
                                                                                    }`}
                                                                                >
                                                                                    <Button>
                                                                                        View
                                                                                    </Button>
                                                                                </Link>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            {item?.seen ? (
                                                                                item?.archive ? (
                                                                                    <HtmlTooltip
                                                                                        title={
                                                                                            <React.Fragment>
                                                                                                <Typography color="inherit">
                                                                                                    Remove
                                                                                                </Typography>
                                                                                            </React.Fragment>
                                                                                        }
                                                                                        placement="top-start"
                                                                                    >
                                                                                        <Button>
                                                                                            <img
                                                                                                src={
                                                                                                    assest.crossGray
                                                                                                }
                                                                                                width={
                                                                                                    9
                                                                                                }
                                                                                                height={
                                                                                                    9
                                                                                                }
                                                                                                alt="icon"
                                                                                            />
                                                                                        </Button>
                                                                                    </HtmlTooltip>
                                                                                ) : (
                                                                                    <Button
                                                                                        onClick={(
                                                                                            event
                                                                                        ) => {
                                                                                            event.stopPropagation();
                                                                                            updateNotificationArchive(
                                                                                                item
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        Archive
                                                                                    </Button>
                                                                                )
                                                                            ) : (
                                                                                <Button
                                                                                    onClick={(
                                                                                        event
                                                                                    ) => {
                                                                                        event.stopPropagation();
                                                                                        updateNotificationSeen(
                                                                                            item
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Mark
                                                                                    as
                                                                                    read
                                                                                </Button>
                                                                            )}
                                                                        </Box>
                                                                    </MenuItem>
                                                                );
                                                            }
                                                        )
                                                    ) : (
                                                        <Stack
                                                            justifyContent={
                                                                "center"
                                                            }
                                                            alignItems={
                                                                "center"
                                                            }
                                                            className={
                                                                styles.noItemForPopup
                                                            }
                                                        >
                                                            <figure>
                                                                <img
                                                                    src={
                                                                        assest.iconLgbluetick
                                                                    }
                                                                    width={34}
                                                                    height={19}
                                                                    alt="icon"
                                                                />
                                                            </figure>
                                                            <Typography variant="body1">
                                                                You're all clear
                                                                - no new
                                                                notifications
                                                            </Typography>
                                                        </Stack>
                                                    )
                                                ) : (
                                                    ""
                                                )}
                                                {/* ======================================= */}
                                                {/* ====== FOR NO NOTIFICATION START ====== */}

                                                {/* ======================================*/}
                                                {/* ====== FOR NO NOTIFICATION END ====== */}

                                                {}
                                            </Box>
                                        </PerfectScrollbar>
                                        <Stack
                                            justifyContent="flex-end"
                                            direction="row"
                                            className={`${styles.popupFooter} ${styles.popupFooterNotification}`}
                                        >
                                            <Button
                                                startIcon={
                                                    <BlueDoubleTickIcon />
                                                }
                                                className={
                                                    styles.bluemarkReadBtn
                                                }
                                                onClick={
                                                    updateNotificationReadAll
                                                }
                                            >
                                                Mark all as read
                                            </Button>
                                            <Button
                                                onClick={() =>
                                                    navigate(
                                                        "/content-buyer-dashboard/notification"
                                                    )
                                                }
                                            >
                                                View all notifications
                                            </Button>
                                        </Stack>
                                    </Menu>
                                </ButtonGroup>
                                <Box className={styles.profile_box}>
                                    <Typography variant="body1">
                                        {`${contentBuyerData?.data?.name} ${contentBuyerData?.data?.last_name}`}{" "}
                                        <span>Content Buyer</span>
                                    </Typography>
                                    <img
                                        src={
                                            contentBuyerData?.data?.avatar
                                                ? getAbsoluteImageURI(
                                                      contentBuyerData?.data
                                                          ?.avatar
                                                  )
                                                : noUser
                                        }
                                        alt=""
                                        width={31}
                                        height={31}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Stack>
                </Toolbar>
            </AppBar>
            <Dialog
                open={purchsereqstModal}
                onClose={purchsereqstModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                        background: "#fff",
                    },
                }}
                sx={dialogContainer}
            >
                <Box className={styles1.ticket_support_modal}>
                    <Box className={styles1.ticket_support_modal_top}>
                        <Typography
                            variant="caption"
                            className={styles1.ticket_coupn_sec}
                        >
                            New purchase request
                        </Typography>

                        <Typography
                            variant="caption"
                            className={styles1.ticket_id_sec}
                        >
                            <strong>PRID:</strong> #15
                        </Typography>
                        <Button
                            className={styles1.cross_icons}
                            onClick={purchsereqstModalClose}
                        >
                            <CrossIcon />
                        </Button>
                    </Box>
                    <Box className={styles1.ticket_support_modal_btms}>
                        <Grid
                            container
                            rowSpacing={2}
                            className={styles1.ticket_support_modal_btms_row}
                        >
                            <Grid item lg={12} xs={12}>
                                <Box className={styles1.ticket_form_modal}>
                                    <Typography
                                        variant="h5"
                                        className={styles1.modal_h5}
                                    >
                                        Video URL
                                    </Typography>
                                    <Box
                                        className={
                                            styles1.status_messages_inputfrm
                                        }
                                    >
                                        <TextField />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={12} xs={12}>
                                <Box className={styles1.ticket_form_modal}>
                                    <Typography
                                        variant="h5"
                                        className={styles1.modal_h5}
                                    >
                                        Notes
                                    </Typography>
                                    <Box
                                        className={`${styles1.status_messages_inputfrm} ${styles1.textareas}`}
                                    >
                                        <TextField
                                            multiline
                                            placeholder="Please make sure to include any notes or details about this video purchase."
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={12} xs={12}>
                                <Box className={styles1.ticket_form_modal}>
                                    <Box
                                        className={styles1.attach_frm_messages}
                                    >
                                        <Box
                                            className={
                                                styles1.input_boxfile_attach
                                            }
                                        >
                                            <Box
                                                className={
                                                    styles1.input_boxfile_outer
                                                }
                                            >
                                                <Typography variant="caption">
                                                    <i>
                                                        <UploadPin />
                                                    </i>{" "}
                                                    Attach a file
                                                </Typography>
                                            </Box>
                                            <TextField
                                                type="file"
                                                className={
                                                    styles1.file_uploaders
                                                }
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid
                                item
                                lg={12}
                                xs={12}
                                className={styles1.submit_sec_btms}
                            >
                                <Box className={styles1.submit_sec_btns_foot}>
                                    <Button
                                        className={styles1.cancel_btn_modal}
                                        onClick={purchsereqstModalClose}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className={styles1.send_btn_modal}
                                        onClick={handleSnackbarClick}
                                    >
                                        Send{" "}
                                        <Typography variant="caption">
                                            now
                                        </Typography>
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
            <Backdrop
                open={snackOpen}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleSnackbarClose}
            >
                <Snackbar
                    open={snackOpen}
                    autoHideDuration={100000}
                    onClose={handleSnackbarClose}
                    message={
                        <>
                            <CircularProgress
                                size={20}
                                thickness={7}
                                color="inherit"
                            />
                            <span className="textSave">Saving</span>
                            {/* <p className='textSave'>Purchase Request Successfully Sent To The Team</p> */}
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px",
                                },
                            },
                        },
                    }}
                />
            </Backdrop>
        </>
    );
}
